import { useCanOpenStep, useExperience } from '@cascade/react/experiences';
import { useI18n } from '@cascade/react/i18n';
import { Divider, Stepper } from '@cascade/ui-library';
import type { TStep } from '@cascade/ui-library';
import classes from './ExperienceStepper.module.scss';

export const ExperienceStepper = () => {
  const { translate } = useI18n();
  const {
    mainSteps,
    activeMainStepId = '',
    completedStepIds,
    isSideStep,
    openStep,
  } = useExperience();

  const canOpenStep = useCanOpenStep();

  const steps = mainSteps.map((step): TStep => ({
    id: step.id,
    title: step.title,
    completion: completedStepIds.includes(step.id) ? 100 : 0,
    disabled: isSideStep,
  }));

  const openClickedStep = (step: TStep) => {
    if (!canOpenStep) {
      return;
    }

    openStep(step.id);
  };

  return (
    <div className={classes['experience-stepper']}>
      <Stepper
        aria-label={translate('experience.steps')}
        steps={steps}
        activeStepId={activeMainStepId}
        onStepClick={openClickedStep}
      />
      <Divider />
    </div>
  );
};
